import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import {
  IUserPermission,
  IUserPermissionsDto,
} from "adminPanel/user/models/IUserPermissionsDto";

export interface PermissionsState {
  isAdmin: boolean;
  hasAllPermissions: boolean;
  permissions: IUserPermission[];
  storeAccessIds: string[];
  isLoaded: boolean;
}

const initialState: PermissionsState = {
  isAdmin: false,
  hasAllPermissions: false,
  permissions: [],
  storeAccessIds: [],
  isLoaded: false,
};

export const permissionsSlice = createSlice({
  name: "permissions",
  initialState,
  reducers: {
    setPermissions: (state, action: PayloadAction<IUserPermissionsDto>) => {
      state.isAdmin = action.payload.hasAllPermissions;
      state.hasAllPermissions = action.payload.hasAllPermissions;
      state.permissions = action.payload.permissions;
      state.storeAccessIds = action.payload.storeAccessIds;
      state.isLoaded = true;
    },
    clearPermissions: (state) => {
      state.isAdmin = false;
      state.hasAllPermissions = false;
      state.permissions = [];
      state.storeAccessIds = [];
      state.isLoaded = false;
    },
  },
});

export const { setPermissions, clearPermissions } = permissionsSlice.actions;

export const selectPermissions = (state: RootState) => state.permissions;
export const selectIsAdmin = (state: RootState) => state.permissions.hasAllPermissions;

export default permissionsSlice.reducer;
